import { memo } from 'react';
import { Img } from 'root/src/client/v2/common/components/ui/image';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Fits artwork into a fixed frame without ever cropping it. Game art reaches us in whatever shape
// its source uses: Twitch box art is portrait 3:4, publisher key art is closer to 2:1, and a plain
// `object-cover` sacrifices whichever dimension does not match, which cuts logos off at the edges.
// The art is contained instead, and the leftover space is filled by a blurred, dimmed copy of the
// same image, so cards keep a uniform height and the frame never shows a bare box.
export const ArtworkFrame = memo(({ src, alt, className, imageClassName, children }) => (<div className={cn('relative overflow-hidden bg-black/40', className)}>
		{src && (<>
				{/* Decorative fill. Scaled up so the blur radius never reveals the image edges, and it
        reuses the same src, so the browser serves it from the foreground image's cache. */}
				<Img src={src} alt="" aria-hidden loading="lazy" className="absolute inset-0 h-full w-full scale-110 object-cover blur-xl brightness-[.35] saturate-150"/>
				<Img src={src} alt={alt} loading="lazy" className={cn('relative h-full w-full object-contain', imageClassName)}/>
			</>)}
		{children}
	</div>));
ArtworkFrame.displayName = 'ArtworkFrame';
